module.exports = __webpack_public_path__ + "img/robot3.a052d014.jpg";